import React, { useEffect } from 'react';
import { Helmet } from 'react-helmet';
import { connect } from 'react-redux';
import { errorAlert as errorAlertAction } from 'scripts/redux/actions/alerts';
import { fetchUserDetails as fetchUserDetailsAction } from 'scripts/redux/actions/user';
import RegistrationStep from 'scripts/constants/RegistrationStep';
import { getDefaultAuthenticatedPath } from 'scripts/utilities/userAccountHelper';
import { userSelector } from 'scripts/redux/selectors/user';
import UserService from 'scripts/services/UserService';
import OnboardingScreen, {
  OnboardingScreenHeader,
} from 'src/components/oldOnboarding/common/onboardingScreen/OnboardingScreen';
import history from 'src/browser/history';
import Paragraph from 'src/design/styleguide/Paragraph';

const AccountApplicationProcessingPage = ({ user, fetchUserDetails, showError }) => {
  useEffect(() => {
    let active = true;
    let timeout;
    let errorShown = false;

    const checkStatus = async () => {
      try {
        const profile = await UserService.getUserDetails(user.id);
        if (!active) return;

        if (profile.nextRegistrationStep !== RegistrationStep.APPLICATION_REVIEW) {
          await fetchUserDetails(user.id);
          if (active) history.replace(getDefaultAuthenticatedPath(profile));
          return;
        }
        errorShown = false;
      } catch (error) {
        if (active && !errorShown) {
          showError(
            `Unable to check your application status. We will retry automatically. ${error.message}`,
          );
          errorShown = true;
        }
      }
      if (active) timeout = setTimeout(checkStatus, 30000);
    };

    checkStatus();
    return () => {
      active = false;
      clearTimeout(timeout);
    };
  }, [user.id, fetchUserDetails, showError]);

  return (
    <OnboardingScreen>
      <Helmet>
        <title>Application in review | BrickX</title>
      </Helmet>
      <OnboardingScreenHeader>
        <h1>
          <strong>Your application is in review</strong>
        </h1>
        <Paragraph>
          Thank you for registering BrickX Account. We are reviewing your
          application. Once complete we'll contact you.
        </Paragraph>
      </OnboardingScreenHeader>
    </OnboardingScreen>
  );
};

export default connect(userSelector, {
  fetchUserDetails: fetchUserDetailsAction,
  showError: errorAlertAction,
})(AccountApplicationProcessingPage);
